module.exports = __webpack_public_path__ + "static/media/hero-bop.b97531ff.png";